import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "root" },
    [
      _vm.isRlgDataLoading
        ? _c("div", [_vm._v("Loading...")])
        : _c(
            "div",
            [
              _c("h4", { staticClass: "pb-2" }, [
                _vm._v("Return Label Generation"),
              ]),
              _c("p", [
                _vm._v(
                  "Before configuring return label generation for partners using self fufilment,\nensure that the partner is eligible for RLG."
                ),
              ]),
              _c(VSwitch, {
                attrs: {
                  label: "Return Label Generation (RLG)",
                  inset: true,
                  disabled:
                    !_vm.isRlgEligible ||
                    _vm.isRlgToggleDisabled ||
                    _vm.isZRSPureActive,
                },
                model: {
                  value: _vm.isRlgEnabled,
                  callback: function ($$v) {
                    _vm.isRlgEnabled = $$v
                  },
                  expression: "isRlgEnabled",
                },
              }),
              _vm.hasRlgChanged
                ? _c(
                    "div",
                    { staticClass: "mt-5" },
                    [
                      _c(VTextarea, {
                        attrs: {
                          filled: "",
                          autofocus: "",
                          label: "Add reason for deactivation",
                        },
                        model: {
                          value: _vm.inputReasonForDeactivation,
                          callback: function ($$v) {
                            _vm.inputReasonForDeactivation = $$v
                          },
                          expression: "inputReasonForDeactivation",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.reasonForDeactivation
                ? _c("div", { staticClass: "mt-3" }, [
                    _c("p", [
                      _vm._v(
                        "Reason for deactivation: " +
                          _vm._s(_vm.reasonForDeactivation)
                      ),
                    ]),
                  ])
                : _vm._e(),
              _c(
                VFlex,
                {
                  staticStyle: { "justify-content": "flex-end" },
                  attrs: { "d-flex": "" },
                },
                [
                  _c(
                    VBtn,
                    {
                      staticClass: "mr-2",
                      attrs: {
                        "data-testid": "cancel-rlg-cta",
                        text: _vm.hasRlgChanged,
                        color: "grey",
                        elevation: "2",
                        disabled: !_vm.hasRlgChanged,
                      },
                      on: { click: _vm.resetRlgInput },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _c(
                    VBtn,
                    {
                      attrs: {
                        "data-testid": "save-rlg-cta",
                        color: "primary",
                        disabled:
                          !_vm.hasRlgChanged || !_vm.inputReasonForDeactivation,
                      },
                      on: { click: _vm.onRlgSaveClicked },
                    },
                    [_vm._v("Save")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
      _c(
        VDialog,
        {
          attrs: { width: "550" },
          model: {
            value: _vm.showRlgChangesModal,
            callback: function ($$v) {
              _vm.showRlgChangesModal = $$v
            },
            expression: "showRlgChangesModal",
          },
        },
        [
          _c(
            VCard,
            [
              _c(
                "mpAlert",
                { staticClass: "text-h6", attrs: { type: "warning" } },
                [
                  _vm._v(
                    "Deactivate label generation in " +
                      _vm._s(_vm.countryName) +
                      " for Partner " +
                      _vm._s(_vm.merchantName) +
                      "?"
                  ),
                ]
              ),
              _c(
                VCardText,
                { staticClass: "pa-2" },
                [
                  _c("p", { staticClass: "p-4" }, [
                    _vm._v(
                      "Return labels will not be generated for customer returns in this country for this partner."
                    ),
                  ]),
                  _c(
                    VCardActions,
                    [
                      _c(VSpacer),
                      _c(
                        VBtn,
                        {
                          attrs: { text: "" },
                          on: {
                            click: function ($event) {
                              _vm.showRlgChangesModal = false
                            },
                          },
                        },
                        [_vm._v("Cancel")]
                      ),
                      _c(
                        VBtn,
                        {
                          attrs: {
                            "data-testid": "confirm-rlg-changes-modal-save",
                            color: "primary",
                            depressed: "",
                            loading: _vm.isRlgSaveLoading,
                          },
                          on: { click: _vm.confirmDisableRlg },
                        },
                        [_vm._v("Deactivate")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }